module.exports = __webpack_public_path__ + "static/media/D.14606c1b.png";